import React from "react";
import ReportItemEntityListRow from "./ReportItemEntityListRow";

export default function DualTextuaryEntity({ entity, children }) {
  return (
    <div className="report-scheme-report-item-row">
      <ReportItemEntityListRow entity={entity} itemName="Denge" />
      {children && children}
    </div>
  );
}
